import React, { useState, useEffect } from 'react'
//Helpers
import { Col, Container, Row } from 'react-bootstrap'
import useQueryProperty from '@hooks/useQueryProperty'
import {
  getAge,
  getBathrooms,
  getEnvironment,
  getOperations,
  getOrientation,
  getPrices,
  getRooms,
  getSurfaces,
  getType,
} from '@helpers/helper.properties'
import { PriceTokko, RealEstateDataPageComponentData } from 'types'

const AboutProperty_1 = ({
  propertyID,
  global_data,
  groupIds,
  groupName,
}: { propertyID: string } & RealEstateDataPageComponentData) => {
  const { data: allPropertyData, isLoading } = useQueryProperty(
    propertyID,
    global_data.pageConfig.keys.tokko,
  )

  const icons_style: string = global_data.pageConfig.design.icons

  const icons =
    icons_style === 'Solid' || icons_style === 'Light' ? `-${icons_style.toLowerCase()}` : ''

  function getFormatePrice(price: string | undefined) {
    if (price?.toString().includes('con')) {
      return price?.toString()
    } else {
      return Intl.NumberFormat('de-DE').format(parseInt(price!))
    }
  }
  const [operationSelected, setOperationSelected] = useState<string>()

  useEffect(() => {
    setOperationSelected(getOperations(allPropertyData)[0])
  }, [allPropertyData])

  function getPriceByOperation(price: PriceTokko[]) {
    const current_price = price?.find(
      (operation) =>
        operation.type === operationSelected ||
        (operation.type.includes('temporario') && operationSelected?.toLowerCase() == 'temporario'),
    )
    // return `${current_price?.currency} ${current_price?.price} - ${
    //   current_price?.period ? current_price?.period : ''
    // }`
    return current_price
  }

  function valideActiveGroup() {
    if (groupIds?.find((group) => group.toString() === allPropertyData?.type?.id?.toString())) {
      return true
    }
    return false
  }

  return (
    <section className={'property-amenities e p-y-config b ' + (isLoading ? 'skeleton' : '')}>
      <Container fluid>
        <Row className="no-gutters justify-content-between align-items-center">
          <Col
            lg={3}
            className="border-right-color pe-lg-6 px-0 px-lg-3"
          >
            <div className="d-lg-block justify-content-around with-border-mobile justify-content-lg-between align-items-center mb-5 mb-lg-0 text-center text-lg-start">
              <div className="div operation-type d-flex justify-content-around flex-row flex-lg-row align-items-center align-items-lg-start flex-wrap">
                {getOperations(allPropertyData).map((operation) => (
                  <span
                    className={
                      'd-flex justify-content-center cursor-pointer mb-0 button-middle ' +
                      (operation.toLowerCase() + ' ') +
                      (operation.toLowerCase() == operationSelected?.toLowerCase() ||
                      (operation.toLowerCase().includes('temporario') &&
                        operationSelected?.toLowerCase()?.includes('temporario'))
                        ? ' active '
                        : '')
                    }
                    onClick={() => setOperationSelected(operation)}
                  >
                    {operation}
                  </span>
                ))}
                <span
                  className={
                    'type text-center d-flex align-center justify-content-center ' +
                    (getOperations(allPropertyData).length % 2 == 0
                      ? ' mx-2 '
                      : 'button-middle m-0 mt-0 active')
                  }
                >
                  {/* {getType(allPropertyData)} */}

                  {valideActiveGroup() ? groupName : getType(allPropertyData)}
                </span>
              </div>
              <div className="price-property mt-3 d-lg-flex justify-content-center flex-column">
                <span className="text-uppercase">Valor</span>
                <h3 style={{ color: 'white' }}>{`${getPriceByOperation(getPrices(allPropertyData))
                  ?.currency} ${getFormatePrice(
                  getPriceByOperation(getPrices(allPropertyData))?.price?.toString(),
                )} `}</h3>
              </div>
            </div>
          </Col>
          <Col
            lg={9}
            className="ps-lg-6"
          >
            <Row className="px-0 no-gutters justify-content-lg-between justify-content-center">
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-prop-type' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">Ambientes</span>
                    <p>{getEnvironment(allPropertyData)}</p>
                  </div>
                </div>
              </Col>
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-rooms' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">Dormitorios</span>
                    <p>{getRooms(allPropertyData)}</p>
                  </div>
                </div>
              </Col>
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-bathroom' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">Baños</span>
                    <p>{getBathrooms(allPropertyData)}</p>
                  </div>
                </div>
              </Col>
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-measure' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">m² totales</span>
                    <p>{getSurfaces(allPropertyData).total_surface}</p>
                  </div>
                </div>
              </Col>
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-measure' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">m² cubiertas</span>
                    <p>{getSurfaces(allPropertyData).roofed}</p>
                  </div>
                </div>
              </Col>
              {getOrientation(allPropertyData) && (
                <Col
                  xs={6}
                  lg={'auto'}
                  className="text-center text-lg-start"
                >
                  <div className="item-amenities">
                    <i className={'icon-orientation' + icons}></i>
                    <div className="d-flex flex-column">
                      <span className="text-uppercase">Orientación</span>
                      <p>{getOrientation(allPropertyData)}</p>
                    </div>
                  </div>
                </Col>
              )}
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-age' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">Antigüedad </span>
                    <p>{getAge(allPropertyData)}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutProperty_1
